import { render } from "./MediaLibraryBrowser.vue?vue&type=template&id=34f09118&scoped=true"
import script from "./MediaLibraryBrowser.vue?vue&type=script&lang=js"
export * from "./MediaLibraryBrowser.vue?vue&type=script&lang=js"

import "./MediaLibraryBrowser.vue?vue&type=style&index=0&id=34f09118&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f09118"]])

export default __exports__